import type { Brand } from '../brand';

interface BrandIdentity {
  /** Lender-facing name in finance copy. Not the BFF's `institutionName` match. */
  financeBrand: 'Carvana' | 'Slate';
  /** The brand's own storefront root. Not a general search destination — callers that
   *  need the native-webview event or the API-provided `carsUrl` still build their own. */
  homeUrl: string;
  /** Post-sale destination once a recent sale is found. Same-origin by design: in production
   *  the brand is domain-derived, so the customer is already on their brand's host and no
   *  absolute URL is needed. */
  postSalePath: string;
  mfeBrand: 'CARVANA' | 'SLATE';
  /** Data-lake contract; the two brands report the cancelled-order action separately. */
  cancelOrderPrimaryActionAnalyticsId: string;
  appraisalLaunchContext: 'purchase' | 'slate';
  stripePublishableKey: string | undefined;
}

const BRAND_IDENTITY: Record<Brand, BrandIdentity> = {
  carvana: {
    financeBrand: 'Carvana',
    homeUrl: '/cars',
    postSalePath: '/my-carvana',
    mfeBrand: 'CARVANA',
    cancelOrderPrimaryActionAnalyticsId: 'pp_cancel_modal_search',
    appraisalLaunchContext: 'purchase',
    stripePublishableKey: process.env.STRIPE_PUBLISHABLE_KEY
  },
  slate: {
    financeBrand: 'Slate',
    homeUrl: 'https://slate.auto',
    postSalePath: '/my',
    mfeBrand: 'SLATE',
    cancelOrderPrimaryActionAnalyticsId: 'pp_cancel_modal_continue',
    appraisalLaunchContext: 'slate',
    stripePublishableKey: process.env.SLATE_STRIPE_PUBLISHABLE_KEY
  }
};

export { BRAND_IDENTITY };
export type { BrandIdentity };
